// extracted by mini-css-extract-plugin
export default {"tooltip":"EP-z","arrow":"FP-z"};